
<main class="d-flex align-items-center min-vh-100 py-3 py-md-0" style="width: 100%;">
  <div class="container">
    <div class="card login-card">
      <div class="row no-gutters">
        

        <div class="col-md-12 terms-container">
        <header class="terms-header">
            <div class="header-content">
                <div class="logo-section">
                    <img src="assets/images/logo-lg-afh.png" alt="AFH Myaccount" class="logo">
                </div>
                <nav class="breadcrumb">
                    <a href="javascript:void(0)" routerLink="/public/oauth2">Accueil</a> > <a href="javascript:void(0)">Légal</a> > <span>Politique de Confidentialité</span>
                </nav>
            </div>
        </header>


        <div class="terms-content" style="height: 600px; overflow: auto;">
            <div class="content-header">
                <h1>Politique de Confidentialité du Service AFH Myaccount</h1>
                <div class="meta-info">
                    <span class="last-update">Dernière mise à jour : <strong>20.03.2024</strong></span>
                </div>
            </div>

            <div class="toc-container">
                <h3>Table des matières</h3>
                <nav class="toc-nav">
                    <a [routerLink]="[]" fragment="introduction" class="toc-link">1. Introduction</a>
                    <a [routerLink]="[]" fragment="donnees" class="toc-link">2. Données Collectées et Finalités</a>
                    <a [routerLink]="[]" fragment="base-juridique" class="toc-link">3. Base Juridique du Traitement</a>
                    <a [routerLink]="[]" fragment="partage" class="toc-link">4. Partage des Données</a>
                    <a [routerLink]="[]" fragment="securite" class="toc-link">5. Sécurité des Données</a>
                    <a [routerLink]="[]" fragment="conservation" class="toc-link">6. Conservation des Données</a>
                    <a [routerLink]="[]" fragment="droits" class="toc-link">7. Vos Droits</a>
                    <a [routerLink]="[]" fragment="cookies" class="toc-link">8. Cookies et Technologies Similaires</a>
                    <a [routerLink]="[]" fragment="modifications" class="toc-link">9. Modifications de la Politique</a>
                    <a [routerLink]="[]" fragment="contact-dpo" class="toc-link">10. Contact du DPO</a>
                </nav>
            </div>

            <article class="terms-article">
                <section id="introduction" class="terms-section">
                    <h2>1. Introduction</h2>
                    <p>Le groupe AFH, en sa qualité de responsable de traitement, attache une importance capitale à la protection de vos données à caractère personnel. Cette politique de confidentialité décrit comment le service AFH Myaccount collecte, utilise et protège vos informations.</p>
                </section>

                <section id="donnees" class="terms-section">
                    <h2>2. Données Collectées et Finalités</h2>
                    <div class="subsection">
                        <h3>2.1. Données de votre profil</h3>
                        <p>Pour créer et gérer votre compte, nous collectons des informations de base (ex. : nom, prénom, adresse e-mail).</p>
                    </div>
                    <div class="subsection">
                        <h3>2.2. Données de connexion</h3>
                        <p>Nous collectons un historique des connexions (logs) incluant la date, l'heure et l'Application Client à laquelle vous vous êtes connecté. Cela nous permet d'assurer la sécurité du Service et de vous fournir un historique de votre activité.</p>
                    </div>
                    <div class="subsection">
                        <h3>2.3. Données partagées avec les Applications Clientes</h3>
                        <p>Conformément au processus de consentement décrit dans les Conditions d'Utilisation, nous partageons uniquement les données que vous avez expressément accepté de transmettre à une Application Client spécifique.</p>
                    </div>
                </section>

                <section id="base-juridique" class="terms-section">
                    <h2>3. Base Juridique du Traitement</h2>
                    <p>Le traitement de vos données est fondé sur :</p>
                    <ul class="commitments-list">
                        <li><strong>L'exécution du contrat</strong> (la gestion de votre compte et la fourniture du service d'authentification).</li>
                        <li><strong>Votre consentement explicite</strong> pour le partage de vos données avec une Application Client tierce.</li>
                        <li><strong>L'intérêt légitime</strong> du groupe AFH pour assurer la sécurité et l'intégrité du Service.</li>
                    </ul>
                </section>

                <section id="partage" class="terms-section">
                    <h2>4. Partage des Données</h2>
                    <p>Nous nous engageons à <strong>ne jamais partager, vendre ou louer</strong> vos données personnelles à des tiers en dehors du processus strict et contrôlé que nous avons mis en place :</p>
                    
                    <div class="subsection">
                        <h3>Partage avec votre consentement</h3>
                        <p>Les données ne sont transmises à une Application Client (partenaire ou entreprise du groupe AFH) qu'après avoir obtenu votre consentement libre, spécifique et éclairé pour cette application précise.</p>
                    </div>
                    
                    <div class="subsection">
                        <h3>Sous-traitants</h3>
                        <p>Nous pouvons faire appel à des prestataires techniques (hébergeurs) qui traitent vos données uniquement sur nos instructions et dans le respect de la présente politique.</p>
                    </div>
                </section>

                <section id="securite" class="terms-section">
                    <h2>5. Sécurité des Données</h2>
                    <p>Nous mettons en œuvre toutes les mesures techniques et organisationnelles nécessaires (incluant le chiffrement) pour protéger vos données contre tout accès, modification, divulgation ou destruction non autorisée.</p>
                </section>

                <section id="conservation" class="terms-section">
                    <h2>6. Conservation des Données</h2>
                    <p>Vos données sont conservées pour la durée nécessaire à la fourniture du Service et pour répondre à nos obligations légales. L'historique de connexion est conservé pour une durée n'excédant pas <strong>[Préciser la durée, ex: 12 mois]</strong>, sauf obligation légale contraire.</p>
                </section>

                <section id="droits" class="terms-section">
                    <h2>7. Vos Droits</h2>
                    <p>Conformément à la réglementation sur la protection des données (RGPD), vous disposez des droits suivants :</p>
                    
                    <div class="rights-grid">
                        <div class="right-item">
                            <h4>Droit d'accès et de rectification</h4>
                            <p>Accéder à vos données et les faire rectifier</p>
                        </div>
                        <div class="right-item">
                            <h4>Droit à l'effacement</h4>
                            <p>"Droit à l'oubli" dans les limites prévues par la loi</p>
                        </div>
                        <div class="right-item">
                            <h4>Droit à la limitation</h4>
                            <p>Limiter le traitement de vos données</p>
                        </div>
                        <div class="right-item">
                            <h4>Droit à la portabilité</h4>
                            <p>Récupérer vos données dans un format structuré</p>
                        </div>
                        <div class="right-item">
                            <h4>Droit de retrait</h4>
                            <p>Retirer votre consentement à tout moment</p>
                        </div>
                        <div class="right-item">
                            <h4>Gestion des consentements</h4>
                            <p>Gérer vos consentements via les paramètres</p>
                        </div>
                    </div>
                    
                    <div class="contact-info">
                        <p>Pour exercer ces droits, veuillez nous contacter à : <strong>[Adresse e-mail dédiée à la protection des données, ex : privacy@afh.com]</strong>.</p>
                    </div>
                </section>

                <section id="cookies" class="terms-section">
                    <h2>8. Cookies et Technologies Similaires</h2>
                    <p>Le Service AFH Myaccount utilise des cookies de session strictement nécessaires au bon fonctionnement du protocole d'authentification OAuth2. Ces cookies techniques sont exemptés de consentement préalable.</p>
                </section>

                <section id="modifications" class="terms-section">
                    <h2>9. Modifications de la Politique de Confidentialité</h2>
                    <p>Nous nous réservons le droit de mettre à jour cette politique. Toute modification substantielle vous sera notifiée via le Service ou par e-mail.</p>
                </section>

                <section id="contact-dpo" class="terms-section">
                    <h2>10. Contact du Délégué à la Protection des Données</h2>
                    <p>Pour toute question concernant le traitement de vos données, vous pouvez nous contacter à : <strong>support@afhunt.com</strong>.</p>
                </section>
            </article>
        </div>

        </div>
      </div>
    </div>
  </div>
</main>